module.exports = __webpack_public_path__ + "img/ok.a3270176.png";